<script>
import {Link} from "@inertiajs/vue3";
import IconDoc from "@js/components/Icons/IconDoc.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import {copyText} from "@js/helpers.ts";
import {useThemeStore} from "@js/store/ThemeStore.js";
import OnlyMobile from "@js/components/DynamicComponents/OnlyMobile.vue";
import OnlyDesktop from "@js/components/DynamicComponents/OnlyDesktop.vue";
import SalesDepartmentPhone from "@js/components/Sections/Links/SalesDepartmentPhone.vue";
import IconPaymentVisa from "@js/components/Icons/IconPaymentVisa.vue";
import IconPaymentMir from "@js/components/Icons/IconPaymentMir.vue";
import IconPaymentMasterCard from "@js/components/Icons/IconPaymentMasterCard.vue";
import IconPaymentMaestro from "@js/components/Icons/IconPaymentMaestro.vue";
import IconPaymentSbp from "@js/components/Icons/IconPaymentSbp.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import {contacts, requisites} from "@js/company_details.ts";

export default {
    name: "Footer",
    components: {
        IconLogo,
        IconPaymentSbp,
        IconPaymentMaestro,
        IconPaymentMasterCard,
        IconPaymentMir,
        IconPaymentVisa,
        SalesDepartmentPhone,
        OnlyDesktop,
        OnlyMobile,
        IconEnvelope,
        IconTelegram,
        IconWhatsApp,
        IconDoc,
        Link
    },
    data() {
        return {
            currentYear: new Date().getFullYear(),
        }
    },
    methods: {
        copyText(text) {
            copyText(text);
            const themeStore = useThemeStore();
            themeStore.addToast(text + " - Скопирован", "success");
        }
    },
    setup() {

        return {contacts, requisites}
    },
}
</script>

<template>
    <footer class="bg-grayBg rounded-t-[32px] md:rounded-t-[64px] mt-16 text-black max-md:pb-20">
        <div class="border-b border-b-gray-200 pt-10 pb-5">
            <div class="container mx-auto my-5">
                <div class="flex justify-between mb-10">
                    <div>
                        <Link :href="route('home')" aria-label="Лого">
                            <IconLogo class="h-auto w-[150px] md:w-[240px]"/>
                        </Link>
                    </div>
                    <div>
                        <div class="mb-2 md:mb-4">
                            <SalesDepartmentPhone
                                class="font-bold text-xl md:text-2xl text-nowrap border-b border-transparent md:hover:border-black transition"/>
                        </div>
                        <div>
                            <ul class="flex flex-row justify-end font-medium mt-0 space-x-2 text-sm">
                                <li class="w-10 h-10 bg-whatsapp rounded-lg md:hover:rounded-[50px] transition-all duration-300">
                                    <a :href="contacts.whatsapp"
                                       class="w-full h-full flex items-center justify-center"
                                       aria-label="WhatsApp" title="WhatsApp">
                                        <IconWhatsApp class="w-6 h-6 text-white"/>
                                    </a>
                                </li>
                                <li class="w-10 h-10 bg-[#0088CC] rounded-lg md:hover:rounded-[50px] transition-all duration-300">
                                    <a :href="contacts.telegram" target="_blank" aria-label="Telegram"
                                       title="Telegram"
                                       class="w-full h-full flex items-center justify-center">
                                        <IconTelegram class="text-white w-5 h-5 -ms-0.5"/>
                                    </a>
                                </li>
                                <li class="h-10 w-10 bg-amber-500 rounded-lg md:hover:rounded-[50px] transition-all duration-300">
                                    <OnlyMobile class="w-full h-full">
                                        <a :href="'mailto:' + contacts.info_mail" title="Email"
                                           class="w-full h-full flex items-center justify-center">
                                            <IconEnvelope class="text-white w-5 h-5"/>
                                        </a>
                                    </OnlyMobile>
                                    <OnlyDesktop @click.prevent="copyText(contacts.info_mail)"
                                                 class="w-full h-full flex items-center justify-center cursor-pointer">
                                        <IconEnvelope class="text-white w-5 h-5"/>
                                    </OnlyDesktop>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-12 gap-5">
                    <div class="col-span-12 md:col-span-8">
                        <div class="grid grid-cols-2 md:grid-cols-3 gap-10 text-sm">
                            <div>
                                <div class="font-bold mb-5">
                                    Компаниям
                                </div>
                                <div class="grid gap-2">
                                    <Link :href="route('B2BForBuilders')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для девелоперов и застройщиков
                                    </Link>
                                    <Link :href="route('B2BForJBI')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для производителей ЖБИ и бетонных заводов
                                    </Link>
                                    <Link :href="route('B2BForLSTC')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для производителей ЛСТК
                                    </Link>
                                    <Link :href="route('B2BForInstallationOrganizations')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для монтажных организаций
                                    </Link>
                                    <Link :href="route('B2BForAgro')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для сельхоз предприятий
                                    </Link>
                                    <Link :href="route('B2BForWorkshops')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Для производственных цехов
                                    </Link>
                                </div>
                            </div>
                            <div>
                                <div class="font-bold mb-5">
                                    Покупателям
                                </div>
                                <div class="grid gap-2">
                                    <Link :href="route('contacts')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Обратная связь
                                    </Link>
                                    <Link :href="route('aboutCompany')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        О компании
                                    </Link>
                                    <Link :href="route('deliveryAndShipping')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Доставка
                                    </Link>
                                    <Link :href="route('aboutPayment')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Способы оплаты
                                    </Link>
                                    <Link :href="route('comingSoon')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Калькулятор
                                    </Link>
                                </div>
                            </div>
                            <div>
                                <div class="font-bold mb-5">
                                    Документы
                                </div>
                                <div class="grid gap-2">
                                    <Link :href="route('priceList')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Прайс-Лист
                                    </Link>
                                    <Link :href="route('privacyPolicy')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Политика конфиденциальности
                                    </Link>
                                    <Link :href="route('publicOffer')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Публичная оферта
                                    </Link>
                                    <Link :href="route('returnGuarantee')"
                                          class="text-sm font-medium text-gray-900 md:hover:text-navHoverColor transition">
                                        Обмен и возврат товара
                                    </Link>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-span-12 md:col-span-1"></div>
                    <div class="col-span-12 md:col-span-3">
                        <div class="flex flex-col gap-5">
                            <div
                                class="flex items-center justify-between p-5 border-2 border-baseColor rounded-xl text-xs font-medium">
                                <IconPaymentVisa class="h-[30px] w-auto"/>
                                <IconPaymentMir class="h-[30px] w-auto"/>
                                <IconPaymentMasterCard class="h-[30px] w-auto"/>
                                <IconPaymentMaestro class="h-[30px] w-auto"/>
                                <IconPaymentSbp class="h-[30px] w-auto"/>
                            </div>
                            <div class="p-5 border-2 text-gray-700 border-baseColor rounded-xl text-xs font-medium">
                                Указанные на сайте цены не являются публичной офертой
                                (ст. 435 и ст. 437 ГК РФ).
                                <br/> <br/>
                                Цены и наличие товара просьба уточнять по телефону в офисе продаж.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="py-2">
            <div class="container mx-auto">
                <div
                    class="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-3 md:space-y-0">
                    <div class="font-bold text-xs order-1 md:order-1">
                        Copyright © {{ currentYear }} ООО «Металлолом-1». Все права защищены.
                    </div>
                    <a href="https://x-devs.ru/" target="_blank"
                       rel="noopener noreferrer" title="Разработано в X-Point.Studio"
                       class="font-bold text-xs order-3 md:order-2 md:md:hover:text-navHoverColor transition">
                        Разработано в X-Point.Studio
                    </a>
                    <div class="font-bold text-xs order-2 md:order-3">
                        ИНН: {{ requisites.inn }} | КПП: {{ requisites.kpp }} | ОГРН: {{ requisites.ogrn }}
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<style scoped lang="scss">

</style>
